import { jsx } from "react/jsx-runtime";
import FacialRecognitionFingerprintMedium from "./FacialRecognitionFingerprintMedium.js";
import { g as getIllustration } from "../../utils.js";
const FacialRecognitionFingerprint = ({ size = 512, color, ...rest }) => {
  const medium = /* @__PURE__ */ jsx(FacialRecognitionFingerprintMedium, { color, ...rest });
  return getIllustration({ size, medium });
};
export {
  FacialRecognitionFingerprint as default
};
//# sourceMappingURL=FacialRecognitionFingerprint.js.map
